import {pageInfo, exportData, addData, deleteData, initEdit, editData, importData, downloadTemplate, updateActiveOffFlag} from './../api';
import { Message } from 'element-ui';
import {getCarTypeList, listCarrier, getPlateColor} from "../../../../api";
import {companyListData} from "../../company/api";
const truck = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null,
    deleteDataObj: null,
    addDataObj: null,
    initEditObj: null,
    editDataObj: null,
    downloadTemplateObj: null,
    importDataObj: null,
    companyObj: null,
    carriageObj: null,
    carBelongObj: null,
    carTypeObj: null,
    plateColorObj: null,
    activeOffObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    ADD_DATA(state, data) {
      state.addDataObj = data;
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
    INIT_EDIT(state, data) {
      state.initEditObj = data;
    },
    EDIT_DATA(state, data) {
      state.editDataObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
    LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
    LIST_CAR_TYPE(state, data) {
      state.carTypeObj = data.obj;
    },
    LIST_PLATE_COLOR(state, data) {
      state.plateColorObj = data.obj;
    },
    ACTIVE_OFF(state, data) {
      state.activeOffObj = data;
    },
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //添加删除
    async addData({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //删除数据
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //修改数据
    async initEdit({ commit }, obj) {
      let resp = await initEdit(obj);
      commit('INIT_EDIT', resp);
    },
    //修改数据
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importData({ commit }, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //机构
    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
    //承运商
    async listCarrier({ commit }, obj) {
      let resp = await listCarrier(obj);
      commit('LIST_CARRIER', resp);
    },
    //车辆类型
    async listCarType({ commit }, obj) {
      let resp = await getCarTypeList(obj);
      commit('LIST_CAR_TYPE', resp);
    },

    //车辆颜色
    async listPlateColor({ commit }, obj) {
      let resp = await getPlateColor(obj);
      commit('LIST_PLATE_COLOR', resp);
    },
    async updateActiveOffFlag({ commit }, obj) {
      let resp = await updateActiveOffFlag(obj);
      commit('ACTIVE_OFF', resp);
    },
  }
}
export default truck



// WEBPACK FOOTER //
// ./src/page/mdm/truck/store/truck.store.js